/* eslint-disable jsdoc/check-param-names, jsdoc/require-param */
import { first, join, last, map, pipe, split, toUpper } from 'lodash/fp';
/**
 * Extract initials from fullname
 *
 * @param {string} fullname - fullname to use for initials
 *
 * @returns {string} initials
 *
 * @example
 * getInitials('John Doe') // returns 'JD
 * getInitials('Smith von Black') //returns 'SB'
 */

export var getInitials = pipe([split(' '), function (words) {
  return [first(words), last(words)];
}, map(first), map(toUpper), join('')]);
export default getInitials;